'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ExamsCoverage } from '@/app/(main)/_components/search-modal/_variants/exams-coverage.component';
import { PartnerExamsCoverage } from '@/app/(main)/_components/search-modal/search-modal.types';
import { Sheet, SheetContent } from '@/components/ui/sheet';

interface LaboratoryCoverageModalProps {
  coverage: PartnerExamsCoverage;
  open: boolean;
  onOpenChange(open: boolean): void;
  onAddMoreExams(): void;
  onSeeSchedules(): void;
}

export function LaboratoryCoverageModal({
  coverage,
  open,
  onOpenChange,
  onAddMoreExams,
  onSeeSchedules,
}: LaboratoryCoverageModalProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="center-v2"
        className="min-[768px]:h-fit min-[768px]:w-[90vw] min-[768px]:rounded-2xl min-[768px]:max-h-[80vh] md:max-h-[80vh] min-[768px]:max-w-[480px] md:max-w-[480px] p-0 flex flex-col"
        hasHeader
        title={`Cobertura de exames em ${coverage.partnerName}`}
        data-testid={DataTestIdEnum.BRANCH_LABORATORY_COVERAGE_MODAL}
      >
        <ExamsCoverage
          coverage={coverage}
          onAddMoreExams={onAddMoreExams}
          onSeeSchedules={onSeeSchedules}
          onClose={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
